import { supplierIdFormat } from "@redotech/redo-ids-cockroach";
import * as z from "zod";
import { CreateSupplierInput } from "./create-supplier";

export const batchCreateSuppliers = {
  name: "batchCreateSuppliers" as const,
  input: z.object({
    suppliers: z
      .array(CreateSupplierInput)
      .min(1)
      .describe("Array of suppliers to create"),
  }),
  output: z.object({
    supplierIds: z
      .array(supplierIdFormat.schema)
      .describe("Array of created supplier IDs"),
  }),
};
